import { render, staticRenderFns } from "./itemDepartment.vue?vue&type=template&id=788b3f76&scoped=true&"
import script from "./itemDepartment.vue?vue&type=script&lang=js&"
export * from "./itemDepartment.vue?vue&type=script&lang=js&"
import style0 from "./itemDepartment.vue?vue&type=style&index=0&id=788b3f76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b3f76",
  null
  
)

/* custom blocks */
import block0 from "../../localization/texts.json?vue&type=custom&index=0&blockType=i18n&issuerPath=C%3A%5CGit%5CAutoIT-DK%5CWeb-Widgets-EasyBooking%5CAutoIT.Web.Widgets.EasyBooking.Website%5Csrc%5Ccomponents%5Cfragments%5CitemDepartment.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
